import { render, staticRenderFns } from "./WritingTableStatus.vue?vue&type=template&id=3a5363a6&"
import script from "./WritingTableStatus.vue?vue&type=script&lang=js&"
export * from "./WritingTableStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports